import React, { useState } from "react";
import "./QuoteTable.css";
import { useNavigate } from "react-router-dom";
import { useChatData } from "../../../Context/chatDataContext";
import AddQuoteModal from "./AddQuoteModal/AddQuoteModal";
import ViewDetailsModal from "../../../components/ViewDetailsModal/ViewDetailsModal";
import { buildAdminQuoteDetailRows } from "../../../utils/viewDetailsBuilders";

const QuoteTable = ({ data = [],page,limit,fetchQuotes }) => {
  const navigate = useNavigate();
  const { setQuote } = useChatData();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const handleChatClick = (quote) => {
    setQuote(quote);
    navigate(`/chat/quote/${quote.id}`);
  };

  return (
    <>
        <div className="add-customer-btn">
          <button
            className="add-booking-btn"
            onClick={() => setIsModalOpen(true)}
          >
            + Add Quote
          </button>

          <AddQuoteModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            fetchQuotes={fetchQuotes}
          />
        </div>

      <div className="quote-table-wrapper">


        <table className="quote-table">
          <thead>
            <tr>
              <th className="td-sr">Sr.</th>
              <th>Event Type</th>
              <th>Event Date</th>
              <th>Event Location</th>
              {/* <th>Duration</th> */}
              <th>Requirements</th>
              <th>Previous Budget</th>
              <th>Current Budget</th>
              <th>Flat/House No.</th>
              <th>Street name</th>
              <th>City</th>
              <th>Postal Code</th>
              <th>State</th>


              <th>Quote Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Details</th>
              <th>Chat</th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="16" className="no-data">
                  No Quotes found
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr key={index}>
                  {/* <td>{index + 1}</td> */}
                     <td className="td-sr">{(page - 1) * limit + index + 1}</td>

                  <td>{item.eventType || "-"}</td>
                  <td>{item.eventDate || "-"}</td>
                  <td>{item.location || "-"}</td>
                  {/* <td>{item.duration}</td> */}
                  <td>{item.requirements}</td>
                  <td>{item.previousBudget || item.budget || "-"}</td>
                  <td>{item.currentBudget || "-"}</td>

                  <td>{item.flatOrHouseNo || "-"}</td>
                  <td>{item.streetName || "-"}</td>
                  <td>{item.city || "-"}</td>
                  <td>{item.postalCode || "-"}</td>
                  <td>{item.state || "-"}</td>

                  <td>{item.quoteName || item.name || "-"}</td>
                  <td>{item.phone || "-"}</td>
                  <td className="email">{item.email || "-"}</td>
                  <td>
                    <button
                      type="button"
                      className="view-details-btn"
                      onClick={() => {
                        setSelectedItem(item);
                        setShowDetailsModal(true);
                      }}
                    >
                      View Details
                    </button>
                  </td>
                  <td>
                    <button
                      className="chat-btn"
                      onClick={() => handleChatClick(item)} // use unique quote id
                    >
                      💬
                    </button>
                  </td>

                </tr>
              )))}
          </tbody>
        </table>
       
      </div>

      <ViewDetailsModal
        isOpen={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title="Quote Details"
        rows={buildAdminQuoteDetailRows(selectedItem)}
      />
    </>

  );
};

export default QuoteTable;
